module.exports = __webpack_public_path__ + "img/about-2.0d3f6834.png";